<div
	[innerHTML]="translation()"
	class="text-center text-xs leading-loose text-dark-tertiary [&>a]:text-link md:text-sm md:leading-relaxed [&>a]:text-dark-tertiary"
	data-test-id="recaptcha-notification"
></div>
